"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reinitialize = reinitialize;
var _context = require("../context");
var _validateConfig = require("../validate-config");
var _sendConfig = require("../dispatch/send-config");
var _show = require("./show");
var _getConfig = require("../get-config");
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Resize IFrame Handler
 * - resizes the SDK iframe
 *
 * @module core-bootstrap-command-reinitialize
 */

/**
* re-initialize an existing SDK with a new configuration object
*
* @param {object} [config] An optional configuration object
* @param {string} id The ID of the target iframe SDK
* @return {boolean} true if the iframe SDK was reinitialized, false otherwise
*/
function reinitialize(config, id) {
  // get the iframe configuration
  var iframeEntry = (0, _context.getIframeConfiguration)(id);
  if (!iframeEntry) {
    return false;
  }

  // update the iframe configuration with the new SDK configuraiton object
  var sdkConfig = (0, _getConfig.getConfig)(config);
  if (!(0, _validateConfig.validateConfig)(sdkConfig)) {
    return false;
  } else {
    iframeEntry.config = sdkConfig;
    (0, _context.setTargetOrigin)(sdkConfig.sdkUrl);
  }

  // ask the SDK to re-initialize itself
  (0, _sendConfig.sendConfig)(iframeEntry);
  (0, _show.show)(id);
  return true;
}
;
//# sourceMappingURL=reinitialize.js.map